import React from 'react';
import { Section } from './ui/Section';
import { Check } from 'lucide-react';
export function WhatsIncluded() {
  const items = ['PDF principal (guía completa)', 'Hojas imprimibles: Descarga + Cierre + Tracker 7 noches', 'Tarjetas de emergencia 3:00am', 'Plan de mañana en 90 segundos (para cerrar sin activarte)'];
  return <Section data-id="element-235">
      <h2 className="text-3xl md:text-4xl text-[#f5f0e8] mb-12 text-center" data-id="element-236">
        Qué incluye "Apaga la Cabeza"
      </h2>

      <div className="space-y-6 max-w-md mx-auto" data-id="element-237">
        {items.map((item, index) => <div key={index} className="flex items-start gap-4 p-4 bg-[#1e2d3d]/50 rounded-sm border border-transparent hover:border-[#c9a04e]/20 transition-colors" data-id="element-238">
            <div className="mt-1 bg-[#c9a04e]/20 p-1 rounded-full" data-id="element-239">
              <Check className="w-4 h-4 text-[#c9a04e]" data-id="element-240" />
            </div>
            <p className="text-lg text-[#f5f0e8]/90" data-id="element-241">{item}</p>
          </div>)}
      </div>
    </Section>;
}